import { Link } from "react-router-dom";
import backupImage from "../assets/images/backup.png"

const Card = ({id, poster, title, overview}) => {

    const image = poster ? `https://image.tmdb.org/t/p/w500/${poster}` : backupImage;

    return (        
        <>            
            <div className="max-w-sm bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 m-3">
                <Link to={`../movie/${id}`} className="nav-link">              
                    <img className="rounded-t-lg" src={image} alt="" />
                </Link>
                <div className="p-5">
                    <Link to={`../movie/${id}`} className="nav-link">      
                        <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">{title}</h5>
                    </Link>
                    <p className="font-normal text-gray-700 dark:text-gray-400">{overview}</p>
                </div>
            </div>
        </>
    );
};

export default Card;